
<kendo-dialog (close)="closeForm()"
              [height]="(afUiWin.calculatedHeightLarge | async)!"
              [width]="(afUiWin.calculatedWidthMedium | async)!"
              class="isg-dialog-editor">
  <kendo-dialog-titlebar>
    Authorization Editor
  </kendo-dialog-titlebar>

  <form novalidate class="k-form" [formGroup]="editForm">

    <kendo-tabstrip [keepTabContent]="true">

      <kendo-tabstrip-tab [title]="'Main Settings'" [selected]="true">

        <ng-template kendoTabContent>

          <div class="isg-auth-editor-tab-main">

            <kendo-formfield>
              <kendo-label [for]="name" text="Name"></kendo-label>
              <kendo-textbox #name
                             formControlName="name"
                             required></kendo-textbox>
              <kendo-formerror>Error: Name is required</kendo-formerror>
            </kendo-formfield>

            <div class="isg-rhs-group">
              <div class="isg-rhs-content">

                <kendo-formfield>
                  <isg-click-filter #isActive
                                          formControlName="isActive"
                                          [nullable]="false"
                                          [textTrue]="'Is Active'"
                                          [textFalse]="'Inactive'"
                                          [isDisabled]="isReadOnlyCustomControl"
                                          [ngClass]="{'isg-isActive': editForm.controls.isActive.value}">
                  </isg-click-filter>
                </kendo-formfield>

                <kendo-formfield>
                  <isg-click-filter #isLocked
                                          formControlName="isLocked"
                                          [nullable]="false"
                                          [textTrue]="'Is Locked'"
                                          [textFalse]="'Not Locked'"
                                          [isDisabled]="isReadOnlyCustomControl"
                                          [ngClass]="{'isg-isLocked': editForm.controls.isLocked.value}">
                  </isg-click-filter>
                </kendo-formfield>

                <kendo-formfield>
                  <isg-click-filter #isConfigLabel
                                          formControlName="isConfigLabel"
                                          [nullable]="false"
                                          [textTrue]="'Is a Configuration Label'"
                                          [textFalse]="'Authorization/Permission Type'"
                                          [isDisabled]="isReadOnlyCustomControl">
                  </isg-click-filter>
                </kendo-formfield>

              </div>
            </div>

            <kendo-formfield>
              <kendo-label [for]="intAppCode"
                           text="Lookup Code"></kendo-label>
              <kendo-textbox #intAppCode
                             formControlName="intAppCode"></kendo-textbox>

            </kendo-formfield>

            <kendo-formfield>
              <kendo-label [for]="sortOrder" text="Sort Order"></kendo-label>
              <kendo-numerictextbox #sortOrder
                                    formControlName="sortOrder"
                                    [decimals]="0"
                                    [format]="'n'"
                                    [style.width.px]="170"></kendo-numerictextbox>
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label [for]="hierarchyName" text="Hierarchy"></kendo-label>
              <kendo-textbox #hierarchyName
                             formControlName="hierarchyName"
                             [readonly]="true"></kendo-textbox>

            </kendo-formfield>

            <kendo-formfield>
              <kendo-label [for]="licenseId" text="Visible only to this License Id"></kendo-label>
              <kendo-textbox #licenseId
                             formControlName="licenseId"
                             appNullableString></kendo-textbox>
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label [for]="intDescription" text="Tooltip"></kendo-label>
              <kendo-textbox #intDescription
                             formControlName="intDescription"></kendo-textbox>
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label [for]="moduleName" text="Has Module Data For"></kendo-label>
              <kendo-textbox #moduleName
                             formControlName="moduleName"
                             [readonly]="true"></kendo-textbox>
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label [for]="info" text="Url/Info"></kendo-label>
              <kendo-textbox #info
                             formControlName="info"></kendo-textbox>
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label [for]="target" text="Url/Info target"></kendo-label>
              <kendo-textbox #target
                             formControlName="target"></kendo-textbox>

            </kendo-formfield>

            <kendo-formfield>
              <kendo-label [for]="appTagId" text="Internal Data Tag Id"></kendo-label>
              <kendo-textbox #appTagId
                             formControlName="appTagId"></kendo-textbox>

            </kendo-formfield>

            <kendo-formfield>
              <kendo-label [for]="appTag" text="Internal Data Tag Code"></kendo-label>
              <kendo-textbox #appTag
                             formControlName="appTag"
                             appNullableString></kendo-textbox>

            </kendo-formfield>

            <kendo-formfield>
              <kendo-label [for]="metaData" text="Meta Data"></kendo-label>
              <kendo-textarea #metaData
                              formControlName="metaData"></kendo-textarea>
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label [for]="description" text="Description"></kendo-label>
              <kendo-textarea #description
                              formControlName="description"></kendo-textarea>

            </kendo-formfield>

          </div>

        </ng-template>

      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab [title]="'Module'">

        <ng-template kendoTabContent>

          <kendo-formfield>
            <kendo-label [for]="moduleId" text="Module Id"></kendo-label>
            <kendo-textbox #moduleId
                           formControlName="moduleId"
                           appNullableString></kendo-textbox>

          </kendo-formfield>

          <kendo-formfield>
            <kendo-label [for]="moduleTarget" text="Module Target"></kendo-label>
            <kendo-textbox #moduleTarget
                           formControlName="moduleTarget"></kendo-textbox>

          </kendo-formfield>

          <kendo-formfield>
            <kendo-label [for]="moduleInfo" text="Module Info"></kendo-label>
            <kendo-textbox #moduleInfo
                           formControlName="moduleInfo"></kendo-textbox>

          </kendo-formfield>

          <kendo-formfield>
            <kendo-label [for]="moduleAppTagId" text="Module Internal Data Tag Id"></kendo-label>
            <kendo-textbox #moduleAppTagId
                           formControlName="moduleAppTagId"
                           appNullableString></kendo-textbox>

          </kendo-formfield>

          <kendo-formfield>
            <kendo-label [for]="moduleHierarchyName" text="Module Hierarchy Name"></kendo-label>
            <kendo-textbox #moduleHierarchyName
                           formControlName="moduleHierarchyName"></kendo-textbox>

          </kendo-formfield>

        </ng-template>

      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab [title]="'Power BI'">
        <ng-template kendoTabContent>

          <kendo-formfield>
            <kendo-label [for]="pbiWorkSpaceId" text="PBI WorkSpace Id"></kendo-label>
            <kendo-textbox #pbiWorkSpaceId
                           formControlName="pbiWorkSpaceId"
                           appNullableString></kendo-textbox>

          </kendo-formfield>
          <kendo-formfield>
            <kendo-label [for]="pbiDashboardId" text="PBI Dashboard Id"></kendo-label>
            <kendo-textbox #pbiDashboardId
                           formControlName="pbiDashboardId"
                           appNullableString></kendo-textbox>

          </kendo-formfield>
          <kendo-formfield>
            <kendo-label [for]="pbiChartId" text="PBI Chart Id"></kendo-label>
            <kendo-textbox #pbiChartId
                           formControlName="pbiChartId"
                           appNullableString></kendo-textbox>

          </kendo-formfield>
          <kendo-formfield>
            <kendo-label [for]="pbiPageSection" text="PBI Page Section"></kendo-label>
            <kendo-textbox #pbiPageSection
                           formControlName="pbiPageSection"
                           appNullableString></kendo-textbox>

          </kendo-formfield>
          <kendo-formfield>

            <isg-click-filter #pbiNavigation
                                    formControlName="pbiNavigation"
                                    [style.width.px]="300"
                                    [nullable]="false"
                                    [textTrue]="'Show Power BI Navigation'"
                                    [textFalse]="'Do Not Show Power BI Navigation'"
                                    [ngClass]="{'isg-isActive': pbiNavigation}"
                                    [isDisabled]="isReadOnlyCustomControl">
            </isg-click-filter>

          </kendo-formfield>

        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab [title]="'System'">
        <ng-template kendoTabContent>

          <kendo-formfield>
            <kendo-label [for]="id" text="Id"></kendo-label>
            <kendo-textbox #id
                           formControlName="id"
                           [readonly]="true"></kendo-textbox>
          </kendo-formfield>

          <kendo-formfield>
            <kendo-label [for]="parentId" text="Parent Id"></kendo-label>
            <kendo-textbox #parentId
                           formControlName="parentId"
                           appNullableString></kendo-textbox>
          </kendo-formfield>

          <kendo-formfield>
            <kendo-label [for]="hierarchyId" text="Hierarchy Id"></kendo-label>
            <kendo-textbox #hierarchyId
                           formControlName="hierarchyId"
                           required></kendo-textbox>
            <kendo-formerror>Hierarchy ID is required</kendo-formerror>
          </kendo-formfield>

          <kendo-formfield>
            <kendo-label [for]="hierarchyLinkId" text="Link to Separate Hierarchy Link Id"></kendo-label>
            <kendo-textbox #hierarchyLinkId
                           formControlName="hierarchyLinkId"
                           appNullableString></kendo-textbox>
          </kendo-formfield>

          <kendo-formfield>
            <kendo-label [for]="authLinkId" text="Link to Separate Authorization Id"></kendo-label>
            <kendo-textbox #authLinkId
                           formControlName="authLinkId"
                           appNullableString></kendo-textbox>
          </kendo-formfield>

          <kendo-formfield>
            <kendo-label text="Last Modified On"></kendo-label>
            <kendo-textbox [readonly]="true"
                           formControlName="lastModifiedOn"
                           [value]="editDataItem?.lastModifiedOn ? (editDataItem!.lastModifiedOn | utcToLocal) : 'Not available'">
            </kendo-textbox>
          </kendo-formfield>

          <kendo-formfield>
            <kendo-label [for]="lastModifiedByName" text="Last Modified By"></kendo-label>
            <kendo-textbox #lastModifiedByName
                           formControlName="lastModifiedByName"
                           [readonly]="true"></kendo-textbox>
          </kendo-formfield>

        </ng-template>

      </kendo-tabstrip-tab>

    </kendo-tabstrip>

  </form>

  <kendo-dialog-actions *ngIf="!isReadOnlyCustomControl">
    <button kendoButton
            themeColor="primary"
            [disabled]="!editForm.valid || !!(editDataItem?.isLocked)"
            (click)="onSave($event)">
      {{ editDataItem ? 'Update' : 'Save' }}
    </button>
    <button kendoButton (click)="onCancel($event)">Cancel</button>
  </kendo-dialog-actions>

</kendo-dialog>
